/**
 * Generate random guid
 *
 * @example
 *
 * {
 *   id: guid()
 * }
 *
 * @remarks this isn't a GUID, but a 10 char random alpha-num
 */
export function guid() {
  return Math.random()
    .toString(36)
    .slice(2);
}
